export default {
  'tipsAllocation.title': '小费管理',
  'tipsAllocation.setting': '小费设置',
  'tipsAllocation.policies': '方案',
  'tipsAllocation.column.name': '方案名',
  'tipsAllocation.column.service_type': '服务类型',
  'tipsAllocation.column.order_sources': '订单来源',
  'tipsAllocation.column.payment_types': '支付方式',
  'tipsAllocation.column.tips_withholding': '小费代扣',
  'tipsAllocation.column.active': '已激活',
  'tipsAllocation.description1': '为了降低计算的错误率，您只能给每个服务类型设置一个已激活的分配方案。',
  'tipsAllocation.description2': '您可能需要一个临时的员工和角色，用来处理特殊的混合小费规则下的餐厅场景。',
  'tipsAllocation.multipleTippingRules': '同时有多个小费规则的情形',
  'tipsAllocation.seeExample': '详见例子',
  'tipsAllocation.mixedRule': '同时有分享消费和保留各自所得的小费的情形',
  'tipsAllocation.suggestion1': '您可以像新建员工角色一样，在“角色 & 员工”页面新建临时的角色',
  'tipsAllocation.description3': '如果您开启了员工现金收入结算，分配的计算会打印在堂食销售的日结单“员工账户”区域上。',
  'tipsAllocation.description4': '如果您已经有活跃的堂食的小费方案，分配的计算会打印在堂食销售的日结单“小费池”区域上。',
  'tipsAllocation.description5': '日结单上的小费分配区域反映了两方面的内容：',
  'tipsAllocation.rule.basis1': '基于该打印日结单的员工所属角色的所有已激活的小费规则',
  'tipsAllocation.rule.basis2': '是否为角色一起分享小费',
  'tipsAllocation.multipleTippingRules.example': `
    <div class="bold title">同时有多个小费规则</div>
    <p class="bold">
      情形：餐厅有多个小费分配规则，比如是普通的桌子还是Hiabchi铁板烧桌子。铁板烧师傅并不会新建订单，只有服务员可以。
    </p>
    <p class="bold">
      POS会把小费计入到开单的员工身上。因此根据桌子种类，可以新建一个临时员工专门做记录小费使用。
    </p>
    <p>
      <span class="bold">临时员工：</span> Hiabchi铁板烧桌子的订单可以用这个临时员工开单。这样餐厅就可以区分来自普通桌子的小费和来自铁板烧桌子的小费了。
    </p>
    <p>
      同时请确保有设置针对临时员工的小费分配规则，系统可以自动帮您计算。
    </p>
  `,
  'tipsAllocation.mixedTipsRule.example': `
    <div class="bold title">同时有分享小费和保留各自所得的小费</div>
    <p class="bold">
      情形：餐厅平时都是员工保留各自所得的小费，但是遇到特殊包场活动时，很多服务员会一起工作并分享小费。
    </p>
    <p class="bold">
      POS会把小费计入到开单的员工身上。因此有特殊包场活动时，可以新建一个临时员工专门做记录小费使用。
    </p>
    <p>
      <span class="bold">临时员工：</span>所有特殊包场的活动的订单可以用这个临时员工开单。这样餐厅就可以区分来自正常运营的小费和来自特殊包场活动的小费了。
    </p>
    <p>
      同时请确保有设置针对临时员工的小费分配规则，系统可以自动帮您计算。
    </p>
  `,
  'tipsAllocation.combinedByRole.example': `
    <div class="bold title">日结单</div>
    <p class="bold">
      例如，如果小费分配方案是角色一起分享小费，某员工打印堂食销售的日结单时，小费分配区域则打印出堂食的所有分配规则下的角色维度的
      计算结果。
    </p>
  `,
  'tipsAllocation.copy.rules': '小费分配规则',
  'tipsAllocation.rules.description': `
    <p>
      目前小费分配方法只提供按<span class="bold">百分比</span>分配，我们将会添加更多的小费分配方法。
    </p>
    <p>
      <span class="bold">贡献人：</span>该角色的小费将会贡献在小费资金池
    </p>
    <p>
      <span class="bold">受益人：</span>该角色将会从小费资金池收到小费
    </p>
  `,
  'tipsAllocation.copy.willTipOut': '将会付出',
  'tipsAllocation.copy.to': '给',
  'tipsAllocation.rule.contributor': '贡献者',
  'tipsAllocation.rule.percentage': '分配百分比',
  'tipsAllocation.rule.tips': '小费',
  'tipsAllocation.rule.categories': '分类',
  'tipsAllocation.rule.recipients': '接收者',
  'tipsAllocation.add.title': '新建方案',
  'tipsAllocation.edit.title': '编辑方案',
  'tipsAllocation.copy.withhold': '扣除一定百分比来承担餐厅的刷卡手续扣费',
  'tipsAllocation.withhold.description': '该费用会在小费分配给受益人后，从贡献人的小费中扣除。',
  'tipsAllocation.copy.isIndividual': '贡献人会一起分享小费或者保留各自所得的小费?',
  'tipsAllocation.allocation.combine': '一起分享小费',
  'tipsAllocation.allocation.individual': '保留各自所得的小费',
  'tipsAllocation.allocation.description': `
    小费资金池统计基于<i>当天</i>工作的、<i>同一</i>角色的所有贡献人。
  `,
  'tipsAllocation.setting.enable': '使用POS分配小费',
  'tipsAllocation.setting.calculationMethod': '计算方式',
  'tipsAllocation.setting.combineOrIndividualTips': '一起分享小费或保留各自所得小费',
  'tipsAllocation.setting.withholding': '小费代扣',
  'tipsAllocation.setting.withholdingTiming': '小费代扣的时机',
  'tipsAllocation.withholdingTiming.beforeTipOut': '在小费分出前',
  'tipsAllocation.withholdingTiming.afterTipOut': '在小费分出后',
  'tipsAllocation.setting.description': '请在新建小费分配方案前设置好。这些设置会在所有已激活的分配方案上生效。',
  'tipsAllocation.setting.enable.label': '是否使用POS来处理小费分配和计算？',
  'tipsAllocation.setting.combineOrIndividualTips.label': '贡献人会一起分享小费或者保留各自所得的小费？',
  'tipsAllocation.setting.calculationMethod.label': '小费分配应该如何计算？',
  'tipsAllocation.calculationBase.sales': '按销售额百分比',
  'tipsAllocation.calculationBase.tipping': '按小费百分比',
  'tipsAllocation.setting.withhold.label': '扣除一定百分比来承担餐厅的刷卡手续扣费',
  'tipsAllocation.setting.withholdTiming.label': '小费代扣的时机',
  'tipsAllocation.withholdingTiming.beforeTipOut.description': '在小费分出前（该费用会在小费分配给受益人之前扣除）',
  'tipsAllocation.withholdingTiming.afterTipOut.description': '在小费分出后（该费用会在小费分配给受益人之后扣除）',
  'tipsAllocation.setting.enableHouseCash': '开启员工现金收入结算',
  'tipsAllocation.enableHouseCash.description': `员工现金收入 = <span class="bold">现金销售 + 现金小费 - (现金小费 + 刷卡小费 + 其他小费) + 刷卡小费手续费代扣</span>`,
  'tipsAllocation.cashTips': '现金小费',
  'tipsAllocation.cardTips': '刷卡小费',
  'tipsAllocation.cashAndCardTips': '现金 & 刷卡小费',
  'tipsAllocation.action.add': '新建方案',
  'tipsAllocation.createSuccess': '创建方案成功',
  'tipsAllocation.updateSuccess': '更新方案成功',
  'tipsAllocation.deleteSuccess': '删除方案成功',
  'tipsAllocation.updateSettingsSuccess': '更新设置成功',
  'tipsAllocation.requiredTipAllocationEnabled': '创建方案前请打开‘使用POS分配小费’开关',
  'tipsAllocation.activatePrompt': '确认要激活此方案吗？',
  'tipsAllocation.deactivatePrompt': '确认要冻结此方案吗？',
  'tipsAllocation.deletePrompt': '确认要删除此方案吗？',

  'tipsAllocation.tipSheet.title': '小费详情',
  'tipsAllocation.tipSheet.section.basicInfo': '基本信息',
  'tipsAllocation.tipSheet.section.tipPool': '小费池',
  'tipsAllocation.tipSheet.section.tipOutDetail': '小费分配',
  'tipsAllocation.tipSheet.section.tipsWithholding': '小费代扣',
  'tipsAllocation.tipSheet.section.tips': '小费代扣',
  'tipsAllocation.tipSheet.section.activity': '操作记录',
  'tipsAllocation.column.date': '日期',
  'tipsAllocation.column.contributors': '贡献人',
  'tipsAllocation.column.recipients': '接收者',
  'tipsAllocation.column.total_tips': '小费总计',
  'tipsAllocation.column.tips_withhold': '小费代扣',
  'tipsAllocation.column.tip_out': '小费分出',
  'tipsAllocation.column.take_home_tips': '所得小费',
  'tipsAllocation.column.recipient_name': '接收人',
  'tipsAllocation.column.recipient_tips': '接收小费',
  'tipsAllocation.column.note': '备注',
  'tipsAllocation.column.status': '状态',
  'tipsAllocation.column.tipsWithholdingAfterTipOut': '小费分出后的代扣',
  'tipsAllocation.column.tipsWithholdingBeforeTipOut': '小费分出前的代扣',
  'tipsAllocation.tipSheet.totalTipOut': '总分出小费',
  'tipsAllocation.tipSheet.tipsRemaining': '分出和代扣后的小费',
  'tipsAllocation.tipSheet.tippingSource': '小费来源',
  'tipsAllocation.tipSheet.tippingItems': '小费明细项',
  'tipSheet.status.paid': '已支付',
  'tipSheet.status.unpaid': '未支付',
};
